import { getGradeApi, getUserInfoApi, getAreaApi } from '../../api/user'
import {setLogOut} from '../../utils/auth'
import {DEFAULT_USER_PHOTO} from '../../config'
import { wrapFnExecOnce } from '../../utils/wrap-fn-exec-once'
import { createMaps } from '../../utils/create-maps'
import { formatDate } from '../../utils/time'
import { getCurrentSubject } from '../common'
import { encryptString } from '../../utils/encrypt-string'

let state = {
  isLogin: 0,
  userID: null,
  userName: '',
  nickname: '',
  userPic: null,
  phone: null,
  realName: '',
  subjectID: null,
  gradeID: null,
  areaID: null,
  areaName: '',
  schoolID: null,
  schoolName: '',
  address: '',
  isVip: false,
  canGetVip: 0,
  group: null,
  defaultArea: [],
  allGrade: []
}

let getters = {
  isLogin (state) {
    return state.isLogin
  },
  isVip (state) {
    return state.isVip
  },
  userNum (state) {
    // let str = _.repeat('0', 9 - state.UserNum.toString().length)
    return String(state.UserNum).padStart('9', '0')
    // return str + state.UserNum.toString()
  },
  userPic (state) {
    return state.userPic || DEFAULT_USER_PHOTO
  },
  userName (state) {
    return state.userName
  },
  nickname (state) {
    return state.nickname || '未设置'
  },
  realName (state) {
    return state.realName || '未设置'
  },
  phone (state) {
    return state.phone
  },
  areaName (state) {
    return state.areaName || '未设置'
  },
  schoolName (state) {
    return state.schoolName || '未设置'
  },
  address (state) {
    return state.address || '未设置'
  },
  allGrade (state) {
    return state.allGrade
  },
  gradeNameMaps (state) {
    return createMaps(state.allGrade, 'gradeID', 'gradeName')
  },
  // payTypes (state) {
  //   return state.payTypes.length >= 2 ? state.payTypes.slice(0, 2) : state.payTypes
  // },
  paperMainTitle (state, getters) {
    let gradeName = getters.gradeNameMaps[state.gradeID]
    return formatDate(new Date()) + (state.schoolName ? `${state.schoolName}` : ``) + (gradeName || ``) + `${state.subjectID}` + '试卷'
  }
}

let mutations = {
  initUserInfo (state, val) {
    state.isLogin = 1
    _.assign(state, val)
  },
  updateIsLogin (state, val) {
    if (!val) {
      // 退出时清空数据
      _.assign(state, {
        userID: null,
        userName: '',
        nickname: '',
        userPic: null,
        phone: null,
        realName: '',
        subjectID: null,
        gradeID: null,
        areaID: null,
        areaName: '',
        schoolID: null,
        address: '',
        isVip: false,
        group: null,
        defaultArea: []
      })
      setLogOut()
    }
    state.isLogin = val
  },
  saveGrade (state, list) {
    state.allGrade = list
  },
  updatePhoto (state, val) {
    state.userPic = val
  },
  updatePhone (state, val) {
    state.phone = val
  }
}

let actions = {
  getUserInfo ({ state, commit }) {
    return new Promise((resolve, reject) => {
      getUserInfoApi().then(res => {
        // res.data.canGetVip = 1
        commit('initUserInfo', res.data)
        console.log('res.data', res.data)
        let subjectID = res.data.subjectID
        let defaultSubject = getCurrentSubject()
        if (subjectID > 0 && defaultSubject._default) {
          commit('common/updateSubject', subjectID, {root: true})
        }
        // if (res.data.canGetVip == 1) {
        //   console.log('免费升级至尊vip')
        //   commit('common/setGetVipDialogVisible', true, {root: true})
        // }
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  getAllGrade: wrapFnExecOnce((setState, {state, commit}, payload, cb) => {
    getGradeApi().then(res => {
      commit('saveGrade', res.data)
      setState('loaded') // 必须调用 setState 记录状态
    }).catch(() => {
      setState('fail') // 必须调用 setState 记录状态
    })
  }),
  getArea ({state, commit}, payload) {
    getAreaApi(payload).then(res => {

    })
  },
  getPayType ({ state, commit }) {
    if (!state.payTypes.length) {
      // getPayType().then(({ data }) => {
      //   commit('savePayTypes', data)
      // })
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
